import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import DeleteModal from "../../components/atoms/DeleteModal";
import InputGroup from "../../components/atoms/InputGroup";
import Loading from "../../components/atoms/Loading";
import TitleDetail from "../../components/atoms/TitleDetail";
import Navbar from "../../components/main/Navbar";
import Table from "../../components/main/Table";
import HeaderServices from "../../components/deviceService/HeaderServices";
import { ServiceDetailUseContext } from "../../context/AdminDashboard/ServiceDetailContext";
import loading from "../../photos/Spinner-1.9s-137px.gif";
import TextArea from "../../components/atoms/TextArea";
import ModalService from "../../components/deviceService/ServiceModal";
import Modaleditdetail from "../../components/deviceService/Modaleditdetail";
const ServiceDetail = () => {
  const {
    getDetail,
    loaded,
    ServiceNumber,
    editService,
    deleteService,
    SerialNumber,
    timeDate,
    detailtext,
    service,
    numberOwner,
    nameOwner,
    closeDeleteModal,
    showDeleteModal,
    RemoveItem,
    showModal,
    closeModal,
    doneedit,
    onchangeTextArea,
    onchangeTypeService

  } = ServiceDetailUseContext();

  const urlParams = new URLSearchParams(window.location.search);
  useEffect(() => {
    const id = urlParams.get("id");
    getDetail(id);
    document.title = "جزئیات خدمات";
  }, []);
  return (
    <div>
      <Navbar titles={["دستگاه‌ها", "خدمات پس از فروش", "جزئیات خدمات"]} />
      {loaded ? (
        <Loading height={"h-80"} />
      ) : (
        <>
          <div
            className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px"
            dir="rtl">
            <HeaderServices
              deleteService={deleteService}
              editService={editService}
              name={ServiceNumber}
            />
            <div className="flex flex-row justify-between w-full gap-5 mt-7.5px">
              <InputGroup
                iconName={"setting"}
                label="شماره خدمات"
                value={ServiceNumber}
                readOnly={true}
              />
              <InputGroup
                iconName={"cpuB"}
                label="شماره سریال دستگاه"
                value={SerialNumber}
                readOnly={true}
              />
              <InputGroup
                iconName={"calendar"}
                label="تاریخ و ساعت ثبت خدمات"
                value={timeDate}
                readOnly={true}
              />
            </div>
            <div className="flex flex-row justify-between w-full gap-5 mt-25">
              <InputGroup
                iconName={"userF"}
                label="نام و نام خانوادگی مالک"
                value={nameOwner}
                readOnly={true}
              />
              <InputGroup
                iconName={"call"}
                label="شماره تماس مالک"
                value={numberOwner.replace("+98", "0")}
                readOnly={true}
              />
              <InputGroup
                iconName={"setting-3"}
                label="نوع خدمات"
                value={service}
                readOnly={true}
              />
            </div>
            <TextArea
              readOnly={true}
              width="mt-25"
              label={"توضیحات"}
              iconName="note-2"
              text={detailtext}
            />
          </div>
          {/* <ModalService SerialNumber={SerialNumber} Addcall={false}/> */}
          <DeleteModal
            text={` مطمئن هستید؟ ${ServiceNumber}آیا برای حذف`}
            showDeleteModal={showDeleteModal}
            closeDeleteModal={closeDeleteModal}
            RemoveItem={RemoveItem}
            title={"اخطار حذفز خدمات"}
          />
          <Modaleditdetail
            Addcall={false}
            SerialNumber={SerialNumber}
            service={service}
            nameOwner={nameOwner}
            numberOwner={numberOwner}
            showModal={showModal}
            closeModal={closeModal}
            onchangeTypeService={onchangeTypeService}
            textdetail={detailtext}
            onchangeTextArea={onchangeTextArea}
            btnClick={doneedit}
            title={ServiceNumber}
          />
        </>
      )}
    </div>
  );
};

export default ServiceDetail;
